// extracted by mini-css-extract-plugin
module.exports = {"img":"gallery_img__3qBkX"};